import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="92"
      height="48"
      viewBox="0 0 241 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9158 128C13.5309 128 16.1465 128 18.761 128C86.2543 128 153.748 128 221.241 128C223.856 128 226.472 128 229.087 128C230.592 128 232.096 128 233.601 128C234.105 128.001 234.592 127.944 235.083 127.827C235.319 127.77 235.55 127.7 235.778 127.618C236.698 127.284 237.451 126.806 238.141 126.11C238.238 126.013 238.331 125.912 238.422 125.809C238.85 125.319 239.185 124.793 239.449 124.199C239.457 124.182 239.464 124.165 239.471 124.148C239.604 123.843 239.711 123.533 239.794 123.211C239.797 123.203 239.799 123.194 239.801 123.186C239.935 122.662 240.001 122.141 240.001 121.6C240.001 117.333 240.001 113.067 240.001 108.8C240.001 74.6669 240.001 40.5333 240.001 6.40026C240.001 2.86572 237.136 0.000610352 233.601 0.000610352C232.096 0.000610352 230.592 0.000610352 229.087 0.000610352C227.872 0.000610352 226.656 0.000610352 225.441 0.000610352C225.407 0.000610352 225.374 0.000610352 225.339 0.000610352C225.29 0.000610352 225.24 0.000610352 225.19 0.000610352C223.874 0.000610352 222.557 0.000610352 221.24 0.000610352C153.748 0.000610352 86.2543 0.000610352 18.7604 0.000610352C17.4441 0.000610352 16.1273 0.000610352 14.811 0.000610352C14.7614 0.000610352 14.7111 0.000610352 14.6614 0.000610352C14.6276 0.000610352 14.5937 0.000610352 14.5598 0.000610352C13.3452 0.000610352 12.1293 0.000610352 10.9147 0.000610352C9.40986 0.000610352 7.90506 0.000610352 6.40026 0.000610352C2.86571 0.000610352 3.33215e-07 2.86628 3.33215e-07 6.40026C3.33215e-07 40.5339 3.33215e-07 74.6669 3.33215e-07 108.8C3.33215e-07 113.067 3.33215e-07 117.333 3.33215e-07 121.6C-0.00112855 125.135 2.86627 127.999 6.40026 128C7.90619 128 9.411 128 10.9158 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.000976562 108.4C0.000976562 108.533 0.000976562 108.666 0.000976562 108.799C0.000976562 113.066 0.000976562 117.333 0.000976562 121.599C0.000976562 125.134 2.86609 127.999 6.4012 127.999C7.906 127.999 9.41084 127.999 10.9156 127.999C13.5307 127.999 16.1463 127.999 18.7608 127.999C48.9213 127.999 135.081 127.999 165.241 127.999C167.856 127.999 226.472 127.999 229.087 127.999C230.591 127.999 232.096 127.999 233.601 127.999C234.105 128 234.592 127.943 235.083 127.826C235.319 127.769 235.55 127.7 235.778 127.617C236.698 127.283 237.451 126.804 238.141 126.109C238.238 126.012 238.332 125.911 238.422 125.808C238.85 125.317 239.186 124.792 239.449 124.197C239.457 124.18 239.464 124.164 239.472 124.147C239.603 123.842 239.711 123.532 239.794 123.211C239.796 123.202 239.799 123.194 239.801 123.185C239.935 122.661 240.001 122.14 240.001 121.599C240.001 117.333 240.001 113.066 240.001 108.799C240.001 108.666 240.001 108.533 240.001 108.4H0.000976562Z"
        fill="url(#paint0_linear_6150_22509)"
      />
      <path
        opacity="0.2"
        d="M19.6013 0C19.3213 0 19.0414 0 18.7614 0C17.4451 0 16.1283 0 14.812 0C14.7623 0 14.7121 0 14.6624 0C14.6286 0 14.5947 0 14.5608 0C13.3455 0 12.1303 0 10.9156 0C9.41084 0 7.906 0 6.4012 0C2.86609 0 0.000976562 2.86569 0.000976562 6.39967C0.000976562 40.5333 0.000976562 74.6663 0.000976562 108.799C0.000976562 113.066 0.000976562 117.333 0.000976562 121.599C0.000976562 125.134 2.86609 127.999 6.4012 127.999C7.906 127.999 9.41084 127.999 10.9156 127.999C13.5307 127.999 16.1463 127.999 18.7608 127.999C19.0408 127.999 19.3208 127.999 19.6007 127.999V0H19.6013Z"
        fill="url(#paint1_linear_6150_22509)"
      />
      <path
        opacity="0.2"
        d="M220.402 6.10352e-05C220.682 6.10352e-05 220.961 6.10352e-05 221.241 6.10352e-05C222.558 6.10352e-05 223.875 6.10352e-05 225.191 6.10352e-05C225.241 6.10352e-05 225.291 6.10352e-05 225.34 6.10352e-05C225.375 6.10352e-05 225.408 6.10352e-05 225.442 6.10352e-05C226.658 6.10352e-05 227.873 6.10352e-05 229.088 6.10352e-05C230.592 6.10352e-05 232.097 6.10352e-05 233.602 6.10352e-05C237.136 6.10352e-05 240.002 2.86575 240.002 6.39973C240.002 40.5333 240.002 74.6664 240.002 108.799C240.002 113.066 240.002 117.333 240.002 121.599C240.002 125.134 237.136 127.999 233.602 127.999C232.097 127.999 230.592 127.999 229.088 127.999C226.472 127.999 223.857 127.999 221.242 127.999C220.962 127.999 220.682 127.999 220.402 127.999V6.10352e-05H220.402Z"
        fill="url(#paint2_linear_6150_22509)"
      />
      <path
        d="M19.857 19.5999C19.6764 19.5999 19.6013 19.6749 19.6013 19.8561C19.6013 49.2856 19.6013 78.7146 19.6013 108.144C19.6013 108.325 19.6764 108.4 19.857 108.4C49.2865 108.4 78.7155 108.4 108.145 108.4C108.327 108.4 108.401 108.325 108.401 108.144C108.401 78.7146 108.401 49.2856 108.401 19.8561C108.401 19.6749 108.327 19.5999 108.145 19.5999C78.7155 19.5999 49.2865 19.5999 19.857 19.5999Z"
        fill="#575756"
      />
      <path
        d="M107.745 20.2558V20.0001H20.2578"
        stroke="#010202"
        strokeWidth="0.158685"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.746 20.0001C107.926 20.0001 108.001 20.0751 108.001 20.2558C108.001 49.4189 108.001 78.5814 108.001 107.744C108.001 107.925 107.926 108 107.746 108C78.5825 108 49.4199 108 20.2574 108C20.0768 108 20.0017 107.925 20.0017 107.744C20.0017 78.5814 20.0017 49.4189 20.0017 20.2558C20.0017 20.0751 20.0768 20.0001 20.2574 20.0001"
        fill="#E3E3E3"
      />
      <path
        d="M64.0017 94.8797C81.056 94.8797 94.8812 81.0544 94.8812 64.0001C94.8812 46.9458 81.056 33.1205 64.0017 33.1205C46.9473 33.1205 33.1221 46.9458 33.1221 64.0001C33.1221 81.0544 46.9473 94.8797 64.0017 94.8797Z"
        fill="url(#paint3_linear_6150_22509)"
      />
      <path
        d="M48.6417 68.5597C51.1602 68.5597 53.2018 66.5181 53.2018 63.9996C53.2018 61.4811 51.1602 59.4394 48.6417 59.4394C46.1232 59.4394 44.0815 61.4811 44.0815 63.9996C44.0815 66.5181 46.1232 68.5597 48.6417 68.5597Z"
        fill="#3C3C3B"
      />
      <path
        d="M79.3614 68.5597C81.8799 68.5597 83.9215 66.5181 83.9215 63.9996C83.9215 61.4811 81.8799 59.4394 79.3614 59.4394C76.8429 59.4394 74.8013 61.4811 74.8013 63.9996C74.8013 66.5181 76.8429 68.5597 79.3614 68.5597Z"
        fill="#3C3C3B"
      />
      <path
        d="M96.6696 98.0237C96.2576 98.4363 96.2576 99.1063 96.6696 99.5195C97.0839 99.9332 97.7511 99.9309 98.1643 99.5183C98.578 99.1063 98.5786 98.4363 98.1654 98.0237C97.7528 97.6105 97.0828 97.6105 96.6696 98.0237Z"
        fill="#575756"
      />
      <path
        d="M93.6544 98.2912C92.9223 98.2912 92.1903 98.2912 91.4582 98.2912C91.3289 98.2907 91.2764 98.2376 91.2764 98.1095C91.2764 96.3439 91.2764 94.5789 91.2764 92.8139C91.2764 92.6846 91.3295 92.6321 91.4582 92.6321C93.2232 92.6321 94.9882 92.6321 96.7532 92.6321C96.8819 92.6321 96.9344 92.6852 96.935 92.8139C96.935 93.546 96.935 94.2786 96.935 95.0113C96.935 95.351 97.075 95.4916 97.4147 95.4916C97.7545 95.4916 97.8957 95.351 97.8957 95.0113C97.8957 94.2786 97.8957 93.546 97.8957 92.8139C97.8946 92.1834 97.3837 91.6731 96.7538 91.672C94.9888 91.672 93.2238 91.672 91.4587 91.672C90.8283 91.6726 90.3169 92.1834 90.3169 92.8139C90.3169 94.5789 90.3169 96.3439 90.3169 98.1095C90.3169 98.7394 90.8283 99.2508 91.4587 99.2513C92.1908 99.2513 92.9229 99.2513 93.655 99.2513C93.9937 99.2513 94.1348 99.1108 94.1348 98.771C94.1348 98.4312 93.9931 98.2912 93.6544 98.2912Z"
        fill="#575756"
      />
      <path
        d="M67.1213 41.6002V33.2876C66.0895 33.1821 65.0492 33.12 64.001 33.12C62.9483 33.12 61.9075 33.1736 60.8813 33.2764V41.5996H67.1213V41.6002Z"
        fill="#3C3C3B"
      />
      <path
        d="M37.6015 59.3102C37.6015 55.5312 37.6015 51.7517 37.6015 47.9733C35.456 51.4994 34.0054 55.4923 33.4189 59.7601C34.663 59.7601 35.907 59.7601 37.1516 59.7601C37.4688 59.7595 37.6015 59.6285 37.6015 59.3102Z"
        fill="#D0D0D0"
      />
      <path
        d="M90.8952 59.7595C92.1262 59.7595 93.3579 59.7595 94.5895 59.7595C94.5816 59.7064 94.5742 59.6534 94.5663 59.5998C94.5584 59.5467 94.5511 59.4931 94.5432 59.44C93.9539 55.4923 92.7229 51.9741 90.7219 48.5203C90.6203 48.3459 90.5057 48.1793 90.4019 48.0078C90.4019 51.7602 90.4019 55.5143 90.4019 59.2667C90.4019 59.6155 90.5458 59.7595 90.8952 59.7595Z"
        fill="#D0D0D0"
      />
      <path
        d="M60.8813 86.4V94.7233C61.9075 94.8261 62.9483 94.8797 64.001 94.8797C65.0543 94.8797 66.0951 94.8255 67.1213 94.7233V86.4H60.8813Z"
        fill="#3C3C3B"
      />
      <path
        d="M37.0749 68.2396C35.8563 68.2396 34.6377 68.2396 33.4185 68.2396C34.0049 72.5085 35.4556 76.5003 37.601 80.0269C37.601 76.2733 37.601 72.5204 37.601 68.7668C37.6016 68.3937 37.4469 68.2396 37.0749 68.2396Z"
        fill="#D0D0D0"
      />
      <path
        d="M91.0137 68.2396C90.5808 68.2396 90.4019 68.4191 90.4019 68.8509C90.4019 72.5768 90.4019 76.3016 90.4019 80.0269C92.5473 76.5003 93.9979 72.5085 94.5844 68.2396C93.394 68.2396 92.2036 68.2396 91.0137 68.2396Z"
        fill="#D0D0D0"
      />
      <path
        d="M62.1046 94.8092C62.7345 94.8504 63.3661 94.8797 64.0017 94.8797C64.6395 94.8797 65.27 94.8537 65.8982 94.8154V85.2712H62.104V94.8092H62.1046Z"
        fill="url(#paint4_linear_6150_22509)"
      />
      <path
        d="M65.8981 33.1906C65.2682 33.1493 64.6366 33.12 64.001 33.12C63.3632 33.12 62.7327 33.146 62.1045 33.1843V42.7285H65.8987V33.1906H65.8981Z"
        fill="url(#paint5_linear_6150_22509)"
      />
      <path
        d="M131.857 19.5999C131.676 19.5999 131.601 19.6749 131.601 19.8561C131.601 49.2856 131.601 78.7146 131.601 108.144C131.601 108.325 131.676 108.4 131.857 108.4C161.286 108.4 190.715 108.4 220.145 108.4C220.327 108.4 220.401 108.325 220.401 108.144C220.401 78.7146 220.401 49.2856 220.401 19.8561C220.401 19.6749 220.327 19.5999 220.145 19.5999C190.716 19.5999 161.286 19.5999 131.857 19.5999Z"
        fill="#575756"
      />
      <path
        d="M219.745 20.2558V20.0001H132.258"
        stroke="#010202"
        strokeWidth="0.158685"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.745 20.0001C219.926 20.0001 220.001 20.0751 220.001 20.2558C220.001 49.4189 220.001 78.5814 220.001 107.744C220.001 107.925 219.926 108 219.745 108C190.582 108 161.42 108 132.257 108C132.077 108 132.001 107.925 132.001 107.744C132.001 78.5814 132.001 49.4189 132.001 20.2558C132.001 20.0751 132.077 20.0001 132.257 20.0001"
        fill="#E3E3E3"
      />
      <path
        d="M176.001 94.8797C193.056 94.8797 206.881 81.0544 206.881 64.0001C206.881 46.9458 193.056 33.1205 176.001 33.1205C158.947 33.1205 145.122 46.9458 145.122 64.0001C145.122 81.0544 158.947 94.8797 176.001 94.8797Z"
        fill="url(#paint6_linear_6150_22509)"
      />
      <path
        d="M160.641 68.5597C163.16 68.5597 165.201 66.5181 165.201 63.9996C165.201 61.4811 163.16 59.4394 160.641 59.4394C158.123 59.4394 156.081 61.4811 156.081 63.9996C156.081 66.5181 158.123 68.5597 160.641 68.5597Z"
        fill="#3C3C3B"
      />
      <path
        d="M191.362 68.5597C193.88 68.5597 195.922 66.5181 195.922 63.9996C195.922 61.4811 193.88 59.4394 191.362 59.4394C188.843 59.4394 186.802 61.4811 186.802 63.9996C186.802 66.5181 188.843 68.5597 191.362 68.5597Z"
        fill="#3C3C3B"
      />
      <path
        d="M208.67 98.0237C208.258 98.4363 208.258 99.1063 208.67 99.5195C209.084 99.9332 209.751 99.9309 210.164 99.5183C210.578 99.1063 210.579 98.4363 210.165 98.0237C209.753 97.6105 209.083 97.6105 208.67 98.0237Z"
        fill="#575756"
      />
      <path
        d="M205.655 98.2912C204.923 98.2912 204.191 98.2912 203.459 98.2912C203.33 98.2907 203.277 98.2376 203.277 98.1095C203.277 96.3439 203.277 94.5789 203.277 92.8139C203.277 92.6846 203.33 92.6321 203.459 92.6321C205.224 92.6321 206.989 92.6321 208.754 92.6321C208.883 92.6321 208.935 92.6852 208.936 92.8139C208.936 93.546 208.936 94.2786 208.936 95.0113C208.936 95.351 209.076 95.4916 209.416 95.4916C209.755 95.4916 209.896 95.351 209.896 95.0113C209.896 94.2786 209.896 93.546 209.896 92.8139C209.895 92.1834 209.384 91.6731 208.755 91.672C206.99 91.672 205.225 91.672 203.46 91.672C202.829 91.6726 202.318 92.1834 202.318 92.8139C202.318 94.5789 202.318 96.3439 202.318 98.1095C202.318 98.7394 202.829 99.2508 203.46 99.2513C204.192 99.2513 204.924 99.2513 205.656 99.2513C205.994 99.2513 206.136 99.1108 206.136 98.771C206.136 98.4312 205.993 98.2912 205.655 98.2912Z"
        fill="#575756"
      />
      <path
        d="M179.122 41.6002V33.2876C178.09 33.1821 177.05 33.12 176.002 33.12C174.949 33.12 173.908 33.1736 172.882 33.2764V41.5996H179.122V41.6002Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.601 59.3102C149.601 55.5312 149.601 51.7517 149.601 47.9733C147.456 51.4994 146.005 55.4923 145.419 59.7601C146.663 59.7601 147.907 59.7601 149.151 59.7601C149.469 59.7595 149.601 59.6285 149.601 59.3102Z"
        fill="#D0D0D0"
      />
      <path
        d="M202.895 59.7595C204.126 59.7595 205.358 59.7595 206.589 59.7595C206.581 59.7064 206.574 59.6534 206.566 59.5998C206.558 59.5467 206.551 59.4931 206.543 59.44C205.954 55.4923 204.723 51.9741 202.722 48.5203C202.62 48.3459 202.505 48.1793 202.402 48.0078C202.402 51.7602 202.402 55.5143 202.402 59.2667C202.402 59.6155 202.546 59.7595 202.895 59.7595Z"
        fill="#D0D0D0"
      />
      <path
        d="M172.881 86.4V94.7233C173.907 94.8261 174.948 94.8797 176.001 94.8797C177.054 94.8797 178.095 94.8255 179.121 94.7233V86.4H172.881Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.075 68.2396C147.856 68.2396 146.637 68.2396 145.418 68.2396C146.005 72.5085 147.455 76.5003 149.601 80.0269C149.601 76.2733 149.601 72.5204 149.601 68.7668C149.601 68.3937 149.447 68.2396 149.075 68.2396Z"
        fill="#D0D0D0"
      />
      <path
        d="M203.013 68.2396C202.581 68.2396 202.402 68.4191 202.402 68.8509C202.402 72.5768 202.402 76.3016 202.402 80.0269C204.547 76.5003 205.998 72.5085 206.584 68.2396C205.394 68.2396 204.203 68.2396 203.013 68.2396Z"
        fill="#D0D0D0"
      />
      <path
        d="M174.104 94.8092C174.734 94.8504 175.366 94.8797 176.001 94.8797C176.639 94.8797 177.27 94.8537 177.898 94.8154V85.2712H174.104V94.8092H174.104Z"
        fill="url(#paint7_linear_6150_22509)"
      />
      <path
        d="M177.899 33.1906C177.269 33.1493 176.637 33.12 176.002 33.12C175.364 33.12 174.733 33.146 174.105 33.1843V42.7285H177.899V33.1906H177.899Z"
        fill="url(#paint8_linear_6150_22509)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6150_22509"
          x1="120.001"
          y1="109.076"
          x2="120.001"
          y2="127.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6150_22509"
          x1="16.56"
          y1="63.9998"
          x2="0.30922"
          y2="63.9998"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6150_22509"
          x1="223.443"
          y1="63.9999"
          x2="239.693"
          y2="63.9999"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6150_22509"
          x1="64.0014"
          y1="94.8798"
          x2="64.0014"
          y2="33.1201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6150_22509"
          x1="64.0017"
          y1="94.7472"
          x2="64.0017"
          y2="85.2421"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6150_22509"
          x1="64.0014"
          y1="33.2524"
          x2="64.0014"
          y2="42.7575"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6150_22509"
          x1="176.001"
          y1="94.8798"
          x2="176.001"
          y2="33.1201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6150_22509"
          x1="176.002"
          y1="94.7472"
          x2="176.002"
          y2="85.2421"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_6150_22509"
          x1="176.001"
          y1="33.2524"
          x2="176.001"
          y2="42.7575"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
